import { useEffect, useState } from 'react';
import api from '@/shared/api/client';
import { Badge } from '@/shared/ui/badge';

/**
 * Où en est la déclaration Enedis du mandat signé de ce client.
 *
 * ⚠️ IL N'INTERPRÈTE RIEN. Le statut vient du serveur
 * (`services/integrations/energrid_declaration.statut_du_client`), qui le lit EN DIRECT
 * sur le dossier Energrid : le webhook le fait avancer sans repasser par le mandat.
 *
 * ⚠️ « DÉCLARÉ » VEUT DIRE « L'ACCÈS AUX DONNÉES DU COMPTEUR EST ACCORDÉ ». Ce n'est pas
 * la déclaration du foyer sur les marchés, que fait l'agrégateur (Joris, 07/10).
 *
 * Une déclaration fabriquée par le bouchon (environnement sans clé Energrid) le dit :
 * sans cette mention, « En cours » serait indiscernable d'une vraie déclaration.
 */
const COULEUR = {
  non_declare: 'bg-amber-50 text-amber-800 border-amber-300',
  en_cours: 'bg-sky-50 text-sky-700 border-sky-200',
  declare: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  refuse: 'bg-red-50 text-red-700 border-red-200',
  erreur: 'bg-red-50 text-red-700 border-red-200',
};

function dateCourte(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('fr-FR',
      { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return ''; }
}

export default function DeclarationEnedis({ clientId }) {
  const [etat, setEtat] = useState(null);

  useEffect(() => {
    let vivant = true;
    api.get(`/clients/${clientId}/declaration-enedis`)
      .then((r) => { if (vivant) setEtat(r.data); })
      .catch(() => { if (vivant) setEtat(null); });
    return () => { vivant = false; };
  }, [clientId]);

  if (!etat) return null;
  return (
    <div className="py-1.5" data-testid="declaration-enedis">
      <div className="flex items-baseline justify-between">
        <span className="text-[13px] text-neutral-400">Enedis</span>
        <Badge variant="outline" className={COULEUR[etat.statut] || COULEUR.erreur}
               data-testid="declaration-enedis-statut">
          {etat.libelle}
        </Badge>
      </div>
      <p className={`text-[12px] text-right mt-0.5 ${etat.a_traiter ? 'text-red-600' : 'text-neutral-400'}`}>
        {etat.raison}
        {etat.date ? ` (${dateCourte(etat.date)})` : ''}
      </p>
      {etat.declaration_simulee && (
        <p className="text-[11px] text-amber-700 text-right">
          Déclaration simulée : elle n'a jamais quitté le serveur.
        </p>
      )}
    </div>
  );
}
